import ReactSdk, { SDKReducers, SDKReducersType } from "@ultrade/react-sdk";
import { combineReducers } from "redux";
import persist from "./persist.reducer";
import { PersistState, SystemState } from "../../interfaces/persist.interface"
import exchange from "./exchange.reducer";
import { IExchange } from "../../interfaces/exchange.interface"
import user from "./user.reducer";
import { IUserState } from "../../interfaces/user.interface"
import amm, { AMM } from "./amm.reducer";
import { settings } from "./settings.reducer";
import { ISettingsState } from "../../interfaces/settings.interfase"
import sdkClient from "./sdkClient.reducer";
import rtkSdkClient from "./rtkSdkClient.reducer";
import wallet, { IWalletState } from "./wallet.reducer";
import widget, { WidgetState } from "./widget.reduser";
import { network } from "./network.reducer";
// import { system } from "./system.reducer";
import { INetworkState } from "../../interfaces/network.interface";
import { RootActionType } from "../_actions";
import { points } from "./points.reducer";
import { PointsSettings } from "../../interfaces";

export interface RootState extends SDKReducersType {
  persist: PersistState,
  exchange: IExchange,
  user: IUserState,
  amm: AMM,
  settings: ISettingsState,
  sdkClient: { instance: any },
  rtkSdkClient: { instance: ReactSdk },
  widget: WidgetState,
  network: INetworkState,
  wallet: IWalletState,
  // system: SystemState,
  points: PointsSettings,
}

export const appReducer = combineReducers({
  persist,
  exchange,
  user,
  amm,
  settings,
  sdkClient,
  rtkSdkClient,
  wallet,
  widget,
  network,
  // system,
  points,
 ...SDKReducers
});

const rootReducer = (state: RootState, action: RootActionType): RootState => {
  if (action.type === "LOGOUT_USERS_PERSIST") {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
